// apps/web/src/lib/omie-aprovacao-piloto.ts — Fase 17.1, Plano 25 (L-60, D-13).
// Regra por papel da aprovação do piloto Omie, igual à da API (OmiePilotoService.aprovarCliente):
// ADMIN exige omie:administrar (só o Admin); GESTAO exige omie:aprovar-piloto (Admin e Gestão).
export type PapelAprovacaoPiloto = 'ADMIN' | 'GESTAO';

export interface OpcoesAprovacaoPiloto {
  /** Papéis que a pessoa pode registrar, na ordem ADMIN, GESTAO. */
  readonly papeis: readonly PapelAprovacaoPiloto[];
  /** Só GESTAO: o papel é fixo e o botão se chama "Aprovar como Gestão". */
  readonly somenteGestao: boolean;
  readonly rotuloBotao: string;
}

export function opcoesDeAprovacao(permissoes: readonly string[] | null): OpcoesAprovacaoPiloto {
  const lista = permissoes ?? [];
  const papeis: PapelAprovacaoPiloto[] = [];
  if (lista.includes('omie:administrar')) papeis.push('ADMIN');
  if (lista.includes('omie:aprovar-piloto')) papeis.push('GESTAO');
  const somenteGestao = papeis.length === 1 && papeis[0] === 'GESTAO';
  return { papeis, somenteGestao, rotuloBotao: somenteGestao ? 'Aprovar como Gestão' : 'Registrar Aprovação' };
}

/** Papel sugerido ao abrir o modal: o primeiro permitido que ainda não tem aprovação; senão o primeiro permitido. */
export function papelInicial(
  papeis: readonly PapelAprovacaoPiloto[],
  jaAprovados: readonly PapelAprovacaoPiloto[],
): PapelAprovacaoPiloto {
  return papeis.find((papel) => !jaAprovados.includes(papel)) ?? papeis[0] ?? 'ADMIN';
}
